const FRACTION_REGEX = /(^n[^e]|^d)/;

function compareResponse(left, op, right) {
  let a;
  let b;

  if (['gt_a_and_lte_b', 'lte_a_or_gt_b'].includes(op)) {
    const split = right.split('|');

    if (split.length === 1) {
      throw new Error(`Expected format "a|b" but got: ${right}`);
    }

    a = split[0];
    b = split[1];
  }

  try {
    const match = op.match(FRACTION_REGEX);

    if (match) {
      op = op.substring(1);
      const indexForLeft = match[0].charAt(0) === 'n' ? 0 : 1;
      left = left.split('/')[indexForLeft];
    }
  } catch (e) {
    return false;
  }

  try {
    if (!['eq', 'ne'].includes(op)) {
      left = parseFloat(left);
      right = parseFloat(right);
    }
  } catch (e) {
    throw new Error('gt, gte, lt, and lte operators must be passed a number from the response');
  }

  switch (op) {
    case 'eq':
      return left === right;
    case 'gt':
      return left > right;
    case 'lt':
      return left < right;
    case 'gte':
      return left >= right;
    case 'lte':
      return left <= right;
    case 'ne':
      return left !== right;
    case 'gt_a_and_lte_b':
      return left > a && left <= b;
    case 'lte_a_or_gt_b':
      return left <= a || left > b;
    default:
      throw new Error(`Unknown operator: ${op}`);
  }
}

function planPassesResponseCheck(plan, responses) {
  const hasNoResponseCheck = plan.question === '';
  if (hasNoResponseCheck) return true;

  // A question of "a|b" passes when any of the listed responses passes
  const answered = plan.question
    .split('|')
    .map((question) => responses.find((r) => r.name === question))
    .filter(Boolean);
  if (answered.length === 0) return plan.required === 'no';

  return answered.some((response) =>
    compareResponse(response.value, plan.operator, plan.response),
  );
}

module.exports = {
  compareResponse,
  planPassesResponseCheck,
};
